import { DATA_IMAGE_URI_PATTERN, MARKDOWN_DATA_IMAGE_PATTERN, type ClipboardPasteSegment } from './types';

/** Unique data-URI image sources from markdown/plain text. */
export function extractDataUriImagesFromMarkdown(text: string): string[] {
  if (!text || !text.includes('data:image')) return [];

  const uris = new Set<string>();

  for (const match of text.matchAll(MARKDOWN_DATA_IMAGE_PATTERN)) {
    const src = match[1];
    if (src?.startsWith('data:image')) {
      uris.add(src);
    }
  }

  for (const match of text.matchAll(DATA_IMAGE_URI_PATTERN)) {
    uris.add(match[0]);
  }

  return Array.from(uris);
}

/** Remove markdown image refs whose URL is a data URI. */
export function stripDataUriImagesFromMarkdown(text: string): string {
  if (!text || !text.includes('data:image')) return text;

  let output = text.replace(MARKDOWN_DATA_IMAGE_PATTERN, '');
  output = output.replace(DATA_IMAGE_URI_PATTERN, '');
  output = output.replace(/\n{3,}/g, '\n\n');

  return output.trim();
}

/** Ordered clipboard segments preserving text/image interleaving from markdown/plain text. */
export function extractOrderedSegmentsFromMarkdown(text: string): ClipboardPasteSegment[] {
  if (!text || !text.includes('data:image')) return [];

  const segments: ClipboardPasteSegment[] = [];
  const allMatches: Array<{ index: number; length: number; dataUri: string }> = [];

  for (const match of text.matchAll(MARKDOWN_DATA_IMAGE_PATTERN)) {
    const src = match[1];
    if (src?.startsWith('data:image')) {
      allMatches.push({ index: match.index ?? 0, length: match[0].length, dataUri: src });
    }
  }

  allMatches.sort((a, b) => a.index - b.index);

  let lastIndex = 0;
  for (const match of allMatches) {
    const before = text.slice(lastIndex, match.index);
    if (before.trim()) {
      segments.push({ kind: 'markdown', text: before });
    }

    segments.push({ kind: 'image', dataUri: match.dataUri });
    lastIndex = match.index + match.length;
  }

  const tail = text.slice(lastIndex);
  if (tail.trim()) {
    segments.push({ kind: 'markdown', text: tail });
  }

  return segments;
}
